export default __webpack_public_path__ + "static/media/loadingAudio.96519bfe.wav";